import React, { useState } from 'react'
import IndSectionTabs from '../../components/IndSectionTabs'

const tabData = [
   {
      id: '01ete',
      title: '01. Custom Media Streaming Platform Development',
      intitle: 'Custom Media Streaming Platform Development',
      icon: '/assets/svg/industries/media/s1.svg',
      content:
         'We design personalized video and audio streaming platforms with on-demand, live streaming, and content recommendations, providing seamless and buffer-free experiences. Our offerings comprise high-performance video encoding, adaptive bitrate streaming, and CDN integration for latency-free playback. We deploy user profiles, watch history, and AI-driven content recommendations. With multi-device support, offline playback, and real-time analytics, we enable businesses to provide smooth, engaging, and scalable streaming experiences.',
   },
   {
      id: '02ete',
      title: '02. Over-The-Top (OTT) Platform Development',
      intitle: 'Over-The-Top (OTT) Platform Development',
      icon: '/assets/svg/industries/media/s2.svg',
      content:
         'Our OTT solutions enable content providers to stream media content across devices, incorporating subscription management, video encoding, and DRM protection. We build multi-platform OTT applications with seamless streaming on mobile, web, and smart TVs. Our offerings include adaptive subscription plans, in-app buying, and payment gateway connections. Through adaptive streaming, recommendations, and dynamic ad insertion, our offerings enable businesses to optimize their viewership and revenue.',
   },
   {
      id: '03ete',
      title: '03. Video Content Management & Distribution Platforms',
      intitle: 'Video Content Management & Distribution Platforms',
      icon: '/assets/svg/industries/media/s3.svg',
      content:
         'We create video CMS solutions that allow businesses to upload, manage, and distribute video content effortlessly while ensuring optimal quality and performance. Our platforms offer intuitive content organization, automated transcoding, and bulk video uploading. We implement video categorization, metadata tagging, and content scheduling. With multi-format support, user permissions, and real-time analytics, we enable seamless content management and effective distribution.',
   },
   {
      id: '04ete',
      title: '04. Music Streaming & Distribution Software Solutions',
      intitle: 'Music Streaming & Distribution Software Solutions',
      icon: '/assets/svg/industries/media/s4.svg',
      content:
         'Our music streaming platforms feature user-centric playlists, smooth playback, and music discovery, enhancing retention and engagement of the user. We build platforms with top-notch audio streaming, offline playability, and AI-based music recommendations. Our solutions include interactive playlists, genre-based libraries, and in-app social sharing. With royalty tracking, dynamic content curation, and subscription management, we help businesses build scalable and revenue-generating music platforms.',
   },
   {
      id: '05ete',
      title: '05. Interactive Gaming Software Development',
      intitle: 'Interactive Gaming Software Development',
      icon: '/assets/svg/industries/media/s5.svg',
      content:
         'We create rich-feature gaming platforms with multiplayer, in-app buying, and real-time engagement, delivering immersive gameplay experiences. Our products span real-time multiplayer matchmaking, live chat, and leaderboards. We integrate in-game currency systems, rewards, and interactive challenges. With cross-platform compatibility, immersive graphics, and AI-powered game mechanics, we help businesses create highly engaging and scalable gaming experiences.',
   },
   {
      id: '06ete',
      title: '06. Podcast & Audio Streaming Application Development',
      intitle: 'Podcast & Audio Streaming Application Development',
      icon: '/assets/svg/industries/media/s6.svg',
      content:
         'Our audio streaming solutions include podcast hosting, audio libraries, and personalized playlists, delivering high-quality sound experiences. We create platforms with multi-episode series management, offline downloads, and seamless playback. Our offerings cover AI-based content recommendation, real-time stream analytics, and listener engagement tools. With monetization features, in-app ads, and subscription options, we enable businesses to maximize revenue and listener retention.',
   },
]

function IndSectionTwo() {
   return (
      <section className="section_secondary_bg">
         <div className="container">
            <h2 className="text-center tech_title section_heading_title mb-2">
               Cutting-Edge Media & Entertainment Software Development Services
            </h2>
            <p className="section_desc end-to-end-section mb-xl-0 mb-4">
               Tap into the potential of digital entertainment and media with our cutting-edge software development offerings. We develop engaging, scalable, and interactive platforms to address the changing demands of content creators, distributors, and consumers.
            </p>
            <IndSectionTabs tabData={tabData} />
         </div>
      </section>
   )
}

export default IndSectionTwo
